import { PartnerOrganization } from '../../API';
import BOOKABLE_SERVICE_BUNDLE_CONFIG from '../../metadata/statsig/BOOKABLE_SERVICE_BUNDLE_CONFIG.json';
import { BookableBundle } from '../../types/BookableServiceBundleConfig';
import hasKey from '../../types/hasKey';
import areBookableBundlesEnabled from './areBookableBundlesEnabled';

export default function getSupportedBookableBundlesForPartnerOrganization(
  partnerOrganization: PartnerOrganization | undefined | null,
): BookableBundle[] {
  if (partnerOrganization == null) return [];
  if (!areBookableBundlesEnabled()) return [];
  if (
    hasKey(
      BOOKABLE_SERVICE_BUNDLE_CONFIG.bookableBundleConfigsByPartnerOrganization,
      partnerOrganization,
    )
  ) {
    return BOOKABLE_SERVICE_BUNDLE_CONFIG.bookableBundleConfigsByPartnerOrganization[
      partnerOrganization
    ];
  }

  return [];
}
